// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__33zD0","selects":"Documents_selects__1enQn"};